export default __webpack_public_path__ + "static/media/loginBackground.a5ccceb5.svg";